import { legalElBlocks } from './legal-el';
import { legalEnBlocks } from './legal-en';
import type { LandingLocale } from '../i18n';
import type { LegalBlock } from './legal-types';

export function getLegalBlocks(locale: LandingLocale): LegalBlock[] {
  return locale === 'en' ? legalEnBlocks : legalElBlocks;
}
